import isFunction from 'utilities/isFunction';

const get = (key, defaultValue) => {
    let value = JSON.parse(sessionStorage.getItem(key))?.value;

    if (value === undefined) {
        value = isFunction(defaultValue) ? defaultValue() : defaultValue;
        set(key, value);
    }

    return value;
};

const set = (key, value) =>
    sessionStorage.setItem(key, JSON.stringify({ value }));

const remove = key => sessionStorage.removeItem(key);

export { get, remove, set };
